// @generated by protoc-gen-es v2.16.0 with parameter "target=ts"
// @generated from file kitecorp/transferify/common/v1/funnel_events.proto (package kitecorp.transferify.common.v1, syntax proto3)
/* eslint-disable */

import type { GenEnum, GenFile, GenMessage, GenService } from "@bufbuild/protobuf/codegenv2";
import { enumDesc, fileDesc, messageDesc, serviceDesc } from "@bufbuild/protobuf/codegenv2";
import type { EmptySchema } from "@bufbuild/protobuf/wkt";
import { file_google_protobuf_empty } from "@bufbuild/protobuf/wkt";
import { file_kitecorp_options_v1_options } from "../../../options/v1/options_pb";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file kitecorp/transferify/common/v1/funnel_events.proto.
 */
export const file_kitecorp_transferify_common_v1_funnel_events: GenFile = /*@__PURE__*/
  fileDesc("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", [file_google_protobuf_empty, file_kitecorp_options_v1_options]);

/**
 * What a reader with no session reports about one paywall appearance. It carries no account, price or campaign, so
 * nothing in it can be joined back to a person.
 *
 * @generated from message kitecorp.transferify.common.v1.ReportPaywallEventRequest
 */
export type ReportPaywallEventRequest = Message<"kitecorp.transferify.common.v1.ReportPaywallEventRequest"> & {
  /**
   * The surface that came on screen, spelled as the api's UpsellMoment constant names it, such as PLAN_UPGRADE.
   *
   * @generated from field: string moment = 1;
   */
  moment: string;

  /**
   * The step of the appearance, spelled as the api's UpsellOfferEventKind constant names it, such as OFFER_SHOWN.
   *
   * @generated from field: string kind = 2;
   */
  kind: string;
};

/**
 * Describes the message kitecorp.transferify.common.v1.ReportPaywallEventRequest.
 * Use `create(ReportPaywallEventRequestSchema)` to create a new message.
 */
export const ReportPaywallEventRequestSchema: GenMessage<ReportPaywallEventRequest> = /*@__PURE__*/
  messageDesc(file_kitecorp_transferify_common_v1_funnel_events, 0);

/**
 * What the browser reports about one personalization-builder event. It carries no identifier, address or free text, so
 * nothing in it can be joined back to a person.
 *
 * @generated from message kitecorp.transferify.common.v1.ReportPersonalizationEventRequest
 */
export type ReportPersonalizationEventRequest = Message<"kitecorp.transferify.common.v1.ReportPersonalizationEventRequest"> & {
  /**
   * What happened, as one of the dotted names the flow publishes, such as personalization.builder.opened.
   *
   * @generated from field: string counter = 1;
   */
  counter: string;

  /**
   * Where it happened: UPLOAD, SEND or LATE.
   *
   * @generated from field: string moment = 2;
   */
  moment: string;
};

/**
 * Describes the message kitecorp.transferify.common.v1.ReportPersonalizationEventRequest.
 * Use `create(ReportPersonalizationEventRequestSchema)` to create a new message.
 */
export const ReportPersonalizationEventRequestSchema: GenMessage<ReportPersonalizationEventRequest> = /*@__PURE__*/
  messageDesc(file_kitecorp_transferify_common_v1_funnel_events, 1);

/**
 * What the browser reports about one event of the recipient funnel. It has one field and no more, because a recipient
 * arrived through a stranger's file and has consented to nothing.
 *
 * @generated from message kitecorp.transferify.common.v1.ReportRecipientEventRequest
 */
export type ReportRecipientEventRequest = Message<"kitecorp.transferify.common.v1.ReportRecipientEventRequest"> & {
  /**
   * What happened, as one of the dotted names the funnel publishes, such as recipient.offer.shown.
   *
   * @generated from field: string counter = 1;
   */
  counter: string;
};

/**
 * Describes the message kitecorp.transferify.common.v1.ReportRecipientEventRequest.
 * Use `create(ReportRecipientEventRequestSchema)` to create a new message.
 */
export const ReportRecipientEventRequestSchema: GenMessage<ReportRecipientEventRequest> = /*@__PURE__*/
  messageDesc(file_kitecorp_transferify_common_v1_funnel_events, 2);

/**
 * What a landing-page visitor saw. Only what the browser itself observes is admitted: payment evidence has no public
 * way in.
 *
 * @generated from message kitecorp.transferify.common.v1.RecordLandingObservationRequest
 */
export type RecordLandingObservationRequest = Message<"kitecorp.transferify.common.v1.RecordLandingObservationRequest"> & {
  /**
   * What the visitor did.
   *
   * @generated from field: kitecorp.transferify.common.v1.RecordLandingObservationRequest.Kind kind = 1;
   */
  kind: RecordLandingObservationRequest_Kind;

  /**
   * Who the visit was and which slide it was on. A message, so its absence is told from an empty one.
   *
   * @generated from field: kitecorp.transferify.common.v1.RecordLandingObservationRequest.LandingAttribution attribution = 2;
   */
  attribution?: RecordLandingObservationRequest_LandingAttribution | undefined;
};

/**
 * Describes the message kitecorp.transferify.common.v1.RecordLandingObservationRequest.
 * Use `create(RecordLandingObservationRequestSchema)` to create a new message.
 */
export const RecordLandingObservationRequestSchema: GenMessage<RecordLandingObservationRequest> = /*@__PURE__*/
  messageDesc(file_kitecorp_transferify_common_v1_funnel_events, 3);

/**
 * Who the visit was and which slide it was on.
 *
 * @generated from message kitecorp.transferify.common.v1.RecordLandingObservationRequest.LandingAttribution
 */
export type RecordLandingObservationRequest_LandingAttribution = Message<"kitecorp.transferify.common.v1.RecordLandingObservationRequest.LandingAttribution"> & {
  /**
   * The visit, a UUID. A visit expires after 24 hours.
   *
   * @generated from field: string visit_id = 1;
   */
  visitId: string;

  /**
   * The experiment exposure of the visit, a UUID.
   *
   * @generated from field: string exposure_id = 2;
   */
  exposureId: string;

  /**
   * The slide that was seen.
   *
   * @generated from field: string slide_id = 3;
   */
  slideId: string;

  /**
   * The first slide the visit saw.
   *
   * @generated from field: string first_slide_id = 4;
   */
  firstSlideId: string;

  /**
   * The slide's position. Absent is not zero: zero is the first position, and an absent position is refused.
   *
   * @generated from field: optional int32 position = 5;
   */
  position?: number | undefined;

  /**
   * Whether the visitor consented to analytics. It must be true, so a request without it is refused.
   *
   * @generated from field: bool analytics_consent = 6;
   */
  analyticsConsent: boolean;

  /**
   * The place on the page the observation came from. Absent means the landing page itself.
   *
   * @generated from field: optional string surface = 7;
   */
  surface?: string | undefined;

  /**
   * The plan the page offered. Absent means the default offer.
   *
   * @generated from field: optional string offer_plan = 8;
   */
  offerPlan?: string | undefined;
};

/**
 * Describes the message kitecorp.transferify.common.v1.RecordLandingObservationRequest.LandingAttribution.
 * Use `create(RecordLandingObservationRequest_LandingAttributionSchema)` to create a new message.
 */
export const RecordLandingObservationRequest_LandingAttributionSchema: GenMessage<RecordLandingObservationRequest_LandingAttribution> = /*@__PURE__*/
  messageDesc(file_kitecorp_transferify_common_v1_funnel_events, 3, 0);

/**
 * What the visitor did.
 *
 * @generated from enum kitecorp.transferify.common.v1.RecordLandingObservationRequest.Kind
 */
export enum RecordLandingObservationRequest_Kind {
  /**
   * Never sent. Present because every proto3 enum needs a zero value.
   *
   * @generated from enum value: KIND_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * A slide of the landing page came into view.
   *
   * @generated from enum value: KIND_SLIDE_VIEWED = 1;
   */
  SLIDE_VIEWED = 1,

  /**
   * The premium panel was opened.
   *
   * @generated from enum value: KIND_PREMIUM_OPENED = 2;
   */
  PREMIUM_OPENED = 2,
}

/**
 * Describes the enum kitecorp.transferify.common.v1.RecordLandingObservationRequest.Kind.
 */
export const RecordLandingObservationRequest_KindSchema: GenEnum<RecordLandingObservationRequest_Kind> = /*@__PURE__*/
  enumDesc(file_kitecorp_transferify_common_v1_funnel_events, 3, 0);

/**
 * The visit to withdraw. The random visit id is the capability to delete it, so the request holds nothing else.
 *
 * @generated from message kitecorp.transferify.common.v1.WithdrawLandingVisitRequest
 */
export type WithdrawLandingVisitRequest = Message<"kitecorp.transferify.common.v1.WithdrawLandingVisitRequest"> & {
  /**
   * The visit, a UUID.
   *
   * @generated from field: string visit_id = 1;
   */
  visitId: string;
};

/**
 * Describes the message kitecorp.transferify.common.v1.WithdrawLandingVisitRequest.
 * Use `create(WithdrawLandingVisitRequestSchema)` to create a new message.
 */
export const WithdrawLandingVisitRequestSchema: GenMessage<WithdrawLandingVisitRequest> = /*@__PURE__*/
  messageDesc(file_kitecorp_transferify_common_v1_funnel_events, 4);

/**
 * The counters of the funnel a browser reports before and beside any sign-in (kitecorp/contracts#69): the paywall, the
 * personalization builder, the recipient page and the landing page. Every method is anonymous. The three counters
 * whose vocabulary is open take plain strings, because a value the api does not know is accepted and discarded, not
 * refused.
 *
 * @generated from service kitecorp.transferify.common.v1.FunnelEventService
 */
export const FunnelEventService: GenService<{
  /**
   * Counts one paywall moment. A value the api does not know is accepted and discarded. A beacon: a repeat counts
   * again, so the call is left with unknown idempotency.
   *
   * @generated from rpc kitecorp.transferify.common.v1.FunnelEventService.ReportPaywallEvent
   */
  reportPaywallEvent: {
    methodKind: "unary";
    input: typeof ReportPaywallEventRequestSchema;
    output: typeof EmptySchema;
  },
  /**
   * Counts one personalization-builder step. A value the api does not know is accepted and discarded. A beacon: a
   * repeat counts again, so the call is left with unknown idempotency.
   *
   * @generated from rpc kitecorp.transferify.common.v1.FunnelEventService.ReportPersonalizationEvent
   */
  reportPersonalizationEvent: {
    methodKind: "unary";
    input: typeof ReportPersonalizationEventRequestSchema;
    output: typeof EmptySchema;
  },
  /**
   * Counts one event of the recipient page. A value the api does not know is accepted and discarded. A beacon: a
   * repeat counts again, so the call is left with unknown idempotency.
   *
   * @generated from rpc kitecorp.transferify.common.v1.FunnelEventService.ReportRecipientEvent
   */
  reportRecipientEvent: {
    methodKind: "unary";
    input: typeof ReportRecipientEventRequestSchema;
    output: typeof EmptySchema;
  },
  /**
   * Records what a landing-page visitor saw. Only a visitor who consented to analytics may be recorded, so a request
   * that does not say so is refused. One exposure is kept per visit and slide, so a repeat with the same ids is a
   * duplicate; the call is left with unknown idempotency like the other beacons.
   *
   * @generated from rpc kitecorp.transferify.common.v1.FunnelEventService.RecordLandingObservation
   */
  recordLandingObservation: {
    methodKind: "unary";
    input: typeof RecordLandingObservationRequestSchema;
    output: typeof EmptySchema;
  },
  /**
   * Deletes the observations and purchase links recorded for one landing-page visit, when the visitor withdraws
   * analytics consent. A repeat, or a visit that is already gone, changes nothing, so the visit is the call's key; a
   * bounded tombstone refuses retries of recordings still queued.
   *
   * @generated from rpc kitecorp.transferify.common.v1.FunnelEventService.WithdrawLandingVisit
   */
  withdrawLandingVisit: {
    methodKind: "unary";
    input: typeof WithdrawLandingVisitRequestSchema;
    output: typeof EmptySchema;
  },
}> = /*@__PURE__*/
  serviceDesc(file_kitecorp_transferify_common_v1_funnel_events, 0);

